module.exports = __webpack_public_path__ + "img/ios_download.72e718d2.png";